import React from 'react';
import PropTypes from 'prop-types';

import { TableCell, TableRow } from '@mui/material';

import OnDeleteIcon from '../../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../../icons/OnEditIcon';
import { formatDate } from '../../../../utils/dateFunctions';

import table from '../../../../commonStyles/tables.module.css';
import tableRow from './physicalActivity.module.css';

const PhysicalActivityRow = ({ row, isDisabled, isDeleteDisabled, onEdit, onDelete }) => {
    return (
        <TableRow hover className={`${table.basicRowStripes}`}>
            <TableCell>{formatDate(row.eventDate)}</TableCell>
            <TableCell>
                <span className={tableRow.alignRow}>{row.vigorousActivityMinutes}</span>
            </TableCell>
            <TableCell>
                <span className={tableRow.alignRow}>{row.moderateActivityMinutes}</span>
            </TableCell>
            <TableCell>
                <span className={tableRow.alignRow}>{row.walkingMinutes}</span>
            </TableCell>
            <TableCell align="right" id="editIcon">
                <OnEditIcon onEdit={(e) => onEdit(e, row)} active={!isDisabled} />
            </TableCell>
            <TableCell align="right">
                <OnDeleteIcon onDelete={() => onDelete(row)} active={!isDeleteDisabled} />
            </TableCell>
        </TableRow>
    );
};

PhysicalActivityRow.propTypes = {
    row: PropTypes.object,
    isDisabled: PropTypes.bool,
    isDeleteDisabled: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func
};

export default PhysicalActivityRow;
